import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState, useCallback } from "react";
import { Button } from "@/components/ui/button";
import Icon from "@/icons";

export const VerifyEmailDialog = ({ children }: { children: React.ReactNode }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const sendEmail = useCallback(async () => {
        try {
            setError(null);
            const response = await fetch('__SITE_BASE__/api/me/email/requestkey', { method: 'POST' });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.message);
            }
            setEmailSent(true);
        } catch (err: any) {
            setError(err.message);
        }
    }, []);

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 max-w-96 sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Verify Email</DialogTitle>
                    <DialogDescription>
                        <div className="bg-brand-green text-white rounded-full w-8 h-8 flex items-center justify-center absolute -top-4 -right-4">
                            <Icon name="exclamation" size="16" />
                        </div>
                        {emailSent ? (
                            <>
                                <div className="items-center justify-center flex w-full flex-col mt-4 mb-4">
                                    <p className="font-bold text-lg">Check your email for a verification link.</p>
                                    <p className="text-center">If you don't receive an email, click the button below to resend the verification email.</p>
                                    <Button onClick={sendEmail} className="bg-brand-green px-5 mt-4 py-2 w-full rounded-lg text-white font-semibold hover:bg-green-500">
                                        Resend Email
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p>Click the button below to send a verification email.</p>
                                <Button onClick={sendEmail} className="bg-brand-green px-5 py-2 w-full mt-4 rounded-lg text-white font-semibold hover:bg-green-500">
                                    Send Email
                                </Button>
                            </>
                        )}
                        {error && <p className="text-red-500 mt-4">{error}</p>}
                    </DialogDescription>
                </DialogHeader>
            </DialogContent>
        </Dialog>
    );
};